import "./dataSection.scss";
import { DataSection as DataSectionShared } from "@shared/src";

interface Props {
  title?: string | React.ReactNode;
  titleSize?: "tiny" | "small" | "medium" | "large" | "giant";
  desc?: string | React.ReactNode;
  typeStr?: string | React.ReactNode;
  children?: JSX.Element;
}
const DataSection = ({ title, desc, typeStr, children, titleSize = "medium" }: Props) => {
  return (
    // <div className="data-section-wrap">
    //   {title && (
    //     <div className={`data-section-top ${titleSize}`}>
    //       <div className={`data-title-wrap ${desc ? "has-desc" : ""}`}>
    //         <h2 className="data-title">{title}</h2>
    //         {typeStr && (
    //           <div className="section-type-str">
    //             <span>*</span>
    //             {typeStr}
    //           </div>
    //         )}
    //       </div>
    //       {desc && <div className="data-desc">{desc}</div>}
    //     </div>
    //   )}
    //   {children && <div className="data-content-wrap">{children}</div>}
    // </div>
    <DataSectionShared
      title={title}
      topDesc={desc}
      typeStr={typeStr}
      children={children}
      titleSize={titleSize}
    />
  );
};

export default DataSection;
